/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Funnels — viewer (app-side). Ports the multipath donut + flow renderers
 *  from the design and drives them from live /plugin/funnels data. Opens on the donut. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  /* Answers "is the deployed file the new one?" without a deploy archaeology session. If the
     console does not say 1.0.1, a stale edge copy is being served — purge the CDN. */
  try { (window.GS_BUILD = window.GS_BUILD || {})["funnels"] = "1.0.7"; } catch (e) {}
  var w = window;
  if (window.__fnWired) return; window.__fnWired = 1;

  var NS = "http://www.w3.org/2000/svg";
  function E(t) { return document.createElementNS(NS, t); }
  function A(e, a) { for (var k in a) e.setAttribute(k, a[k]); return e; }
  var root, svg, tip;
  function q(s) { return root ? root.querySelector('[data-f="' + s + '"]') : null; }
  function qa(s) { return root ? Array.prototype.slice.call(root.querySelectorAll(s)) : []; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function ready(fn) { var done = false; function go() { if (done) return; done = true; fn(); } document.addEventListener("gs:ready", go, { once: true }); var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30); if (window.GS && GS.api && GS.site) go(); }

  // live data model (populated from the backend)
  var DATA = { nodes: {}, flows: [] }, SEG = [], DIST = [], ENTRY = 1, PATHS = [], MODE = "donut";

  /* ---- Behavioural badges from Visitor Intelligence ------------------------------------------
     Funnel nodes that correspond to a page get the VI behavioural class (hot / confusing / friction /
     attention / drop-off / cold). Classifier copied verbatim from the Hub map so classes agree across
     surfaces. Event-only steps have no page path and stay un-badged. Read-only; graceful if VI is off. */
  var BMAP = {
    hot:       { label: "Hot",            color: "#1FA463" },
    confusing: { label: TR('funnel.g.confusing'),      color: "#D97706" },
    friction:  { label: TR('funnel.g.high_friction'),  color: "#E0533D" },
    attention: { label: TR('funnel.g.high_attention'), color: "#6C4BE8" },
    dropoff:   { label: TR('funnel.g.drop_off'),       color: "#EA580C" },
    cold:      { label: TR('funnel.g.cold'),           color: "#8798B0" },
    neutral:   { label: TR('funnel.g.neutral'),        color: "#5C6E88" }
  };
  function normPath(p) { p = String(p == null ? "" : p); var i = p.indexOf("?"); if (i >= 0) p = p.slice(0, i); i = p.indexOf("#"); if (i >= 0) p = p.slice(0, i); p = p.trim(); return p === "" ? "/" : p; }
  function classifyPage(p) {
    var i = p.intent || 0, f = p.frustration || 0, a = p.attention || 0, v = p.views || 0, er = v ? (p.exits || 0) / v : 0;
    var primary;
    if (f >= 55 && a >= 40 && i >= 40) primary = "confusing";
    else if (er >= 0.5 && i < 45) primary = "dropoff";
    else if (i >= 60 && f < 45) primary = "hot";
    else if (f >= 50) primary = "friction";
    else if (a >= 60) primary = "attention";
    else if (i < 30 && a < 35) primary = "cold";
    else primary = "neutral";
    return { primary: primary };
  }
  var BEHAV = null, BEHAVKEY = "";
  function behavOf(path) { return (BEHAV && path) ? BEHAV[normPath(path)] : null; }
  function loadBehav() {
    var key = ((window.GS && GS.site) || "") + "|" + RANGE.from + "|" + RANGE.to;
    if (BEHAVKEY === key && BEHAV) return;
    BEHAVKEY = key;
    GS.api("/plugin/visitor-intelligence/behaviormap?" + siteParam() + rangeParam()).then(function (r) {
      var d = r && r.data ? r.data : r; BEHAV = {};
      if (d && d.ok && d.pages) d.pages.forEach(function (p) { BEHAV[normPath(p.page)] = classifyPage(p); });
      if (DATA.nodes && DATA.nodes.A) render(MODE);
    }).catch(function () { BEHAV = {}; });
  }

  /* ---------- tooltips ---------- */
  function showTip(html, x, y) {
    tip.innerHTML = html; tip.classList.add("show");
    var w = tip.offsetWidth, h = tip.offsetHeight, px = x + 14, py = y + 14;
    if (px + w > window.innerWidth - 8) px = x - w - 14;
    if (py + h > window.innerHeight - 8) py = y - h - 14;
    tip.style.left = px + "px"; tip.style.top = py + "px";
  }
  function hideTip() { tip.classList.remove("show"); }
  /* `d` is a distribution aligned to SEG. Pass a path's OWN measured one where we have it; the
     entry distribution is only a sensible answer for the entry node itself. Multiplying a path's
     conversions by the entry split produced a plausible-looking breakdown that nobody measured. */
  function srcRows(u, d) { d = d || DIST; return SEG.map(function (s, i) { return { k: s.k, c: s.c, v: Math.round(u * (d[i] || 0)) }; }); }
  function nodeTip(n) {
    var pct = (n.users / ENTRY * 100).toFixed(1);
    var rows = srcRows(n.users).map(function (r) { return '<div class="tr"><span class="nm"><i style="background:' + r.c + '"></i>' + r.k + '</span><b>' + r.v.toLocaleString() + '</b></div>'; }).join("");
    var cls = behavOf(n.path);
    var beh = cls ? '<div class="tr" style="color:#8A93A0"><span>behaviour</span><b style="color:' + BMAP[cls.primary].color + '">' + BMAP[cls.primary].label + '</b></div>' : "";
    return '<div class="tt">' + n.stage + ' \u00b7 ' + esc(n.name) + '</div><div class="big">' + n.users.toLocaleString() + '</div>' +
      '<div class="tr" style="color:#8A93A0"><span>of entry</span><b style="color:#fff">' + pct + '%</b></div>' + beh + '<div style="height:6px"></div>' + rows;
  }
  function flowTip(f) {
    if (!f) return "";
    var src = DATA.nodes[f.from], conv = src.users ? (f.value / src.users * 100).toFixed(1) : "0.0";
    return '<div class="tt">' + DATA.nodes[f.from].stage + ' \u2192 ' + DATA.nodes[f.to].stage + '</div><div class="big">' + conv + '%</div>' +
      '<div class="tr"><span>continued</span><b>' + f.value.toLocaleString() + '</b></div>' +
      '<div class="tr"><span>dropped</span><b>' + (src.users - f.value).toLocaleString() + '</b></div>';
  }

  function spotlight(path) {
    if (!path) { svg.classList.remove("dim"); return; }
    svg.classList.add("dim");
    svg.querySelectorAll(".node,.ribbon").forEach(function (g) {
      var p = g.getAttribute("data-path"); g.classList.toggle("hot", p === "all" || p === path);
    });
  }

  /* ---------- flow (Sankey-style) ---------- */
  function ribbonPath(x1, y1, w1, x2, y2, w2) {
    var dx = (x2 - x1) * 0.5;
    return "M" + x1 + "," + y1 + " C" + (x1 + dx) + "," + y1 + " " + (x2 - dx) + "," + y2 + " " + x2 + "," + y2 +
      " L" + x2 + "," + (y2 + w2) + " C" + (x2 - dx) + "," + (y2 + w2) + " " + (x1 + dx) + "," + (y1 + w1) + " " + x1 + "," + (y1 + w1) + " Z";
  }
  function renderFlow() {
    svg.setAttribute("viewBox", "0 0 1180 440");
    var yMid = 205, MAXH = 270, NODE_MIN = 20, FLOW_MIN = 5, BARW = 64, scale = MAXH / Math.max(1, ENTRY);
    function hn(v) { return Math.max(NODE_MIN, v * scale); }
    function hf(v) { return Math.max(FLOW_MIN, v * scale); }
    var colX = { A: 140, B: 430, C: 730, D: 1010 }, N = {};
    for (var k in DATA.nodes) { var d = DATA.nodes[k]; N[k] = { d: d, cx: colX[d.stage], h: hn(d.users) }; N[k].left = N[k].cx - BARW / 2; N[k].right = N[k].cx + BARW / 2; }
    var gap = 46, gH = N.C1.h + gap + N.C2.h, gTop = yMid - gH / 2;
    N.C1.top = gTop; N.C1.cy = gTop + N.C1.h / 2;
    N.C2.top = gTop + N.C1.h + gap; N.C2.cy = N.C2.top + N.C2.h / 2;
    ["A", "B", "D"].forEach(function (id) { N[id].cy = yMid; N[id].top = yMid - N[id].h / 2; });

    var defs = E("defs");
    var lg = A(E("linearGradient"), { id: "flowg", x1: "0", x2: "1" });
    lg.appendChild(A(E("stop"), { offset: "0", "stop-color": "#2A6FE8", "stop-opacity": ".30" }));
    lg.appendChild(A(E("stop"), { offset: ".5", "stop-color": "#2A6FE8", "stop-opacity": ".14" }));
    lg.appendChild(A(E("stop"), { offset: "1", "stop-color": "#2A6FE8", "stop-opacity": ".30" }));
    defs.appendChild(lg); svg.appendChild(defs);

    var outAt = {}, inAt = {};
    DATA.flows.forEach(function (f) {
      var s = N[f.from], t = N[f.to], w = hf(f.value);
      var sy = (outAt[f.from] === undefined) ? s.top : outAt[f.from]; f.y1 = sy; outAt[f.from] = sy + w; f.x1 = s.right;
      var ty = (inAt[f.to] === undefined) ? t.top : inAt[f.to]; f.y2 = ty; inAt[f.to] = ty + w; f.x2 = t.left; f.w = w;
    });

    var gRib = A(E("g"), { class: "grp" });
    DATA.flows.forEach(function (f) {
      var p = A(E("path"), { d: ribbonPath(f.x1, f.y1, f.w, f.x2, f.y2, f.w), fill: "url(#flowg)", class: "ribbon", "data-path": f.path });
      p.__tip = function () { return flowTip(f); }; p.__spot = f.path; gRib.appendChild(p);
      var mx = (f.x1 + f.x2) / 2, my = ((f.y1 + f.w / 2) + (f.y2 + f.w / 2)) / 2 - 8;
      var t = A(E("text"), { x: mx, y: my, "text-anchor": "middle", "font-size": "12.5", "font-weight": "800", fill: "#2A6FE8", "paint-order": "stroke", stroke: "#fff", "stroke-width": "4", "stroke-linejoin": "round", "pointer-events": "none" });
      t.textContent = (f.value / Math.max(1, N[f.from].d.users) * 100).toFixed(1) + "%"; gRib.appendChild(t);
    });
    svg.appendChild(gRib);

    ["A", "B", "D", "C1", "C2"].forEach(function (id) {
      var n = N[id], d = n.d, r = Math.min(10, n.h / 2, BARW / 2), cid = "cl_" + id;
      var cp = A(E("clipPath"), { id: cid }); cp.appendChild(A(E("rect"), { x: n.left, y: n.top, width: BARW, height: n.h, rx: r })); defs.appendChild(cp);
      var g = A(E("g"), { class: "grp" });
      var hit = A(E("g"), { class: "node", "data-path": d.path || "all" }); hit.__tip = function () { return nodeTip(d); }; hit.__spot = d.path || null;
      var seg = A(E("g"), { "clip-path": "url(#" + cid + ")" }), y = n.top;
      DIST.forEach(function (frac, i) { seg.appendChild(A(E("rect"), { x: n.left, y: y, width: BARW, height: frac * n.h + 0.6, fill: SEG[i].c })); y += frac * n.h; });
      hit.appendChild(seg);
      hit.appendChild(A(E("rect"), { x: n.left, y: n.top, width: BARW, height: n.h, rx: r, fill: "none", stroke: "rgba(16,24,40,.10)" }));
      g.appendChild(hit);
      var bcls = behavOf(d.path);
      if (bcls) g.appendChild(A(E("circle"), { cx: n.right - 6, cy: n.top + 7, r: 4.5, fill: BMAP[bcls.primary].color, stroke: "#fff", "stroke-width": 1.4, "pointer-events": "none" }));
      function T(x, yy, s, o) { o = o || {}; var t = A(E("text"), { x: x, y: yy, "text-anchor": o.a || "middle", "font-size": o.s || "13", "font-weight": o.w || "600", fill: o.f || "#3C4350", "pointer-events": "none" }); t.textContent = s; g.appendChild(t); }
      function badge(x, yy, L) { g.appendChild(A(E("circle"), { cx: x, cy: yy, r: 8.5, fill: "#EEF1F5" })); T(x, yy + 3.5, L, { s: "10.5", w: "700", f: "#6B7480" }); }
      if (d.stage === "A") {
        g.appendChild(A(E("rect"), { x: n.left, y: n.top - 5, width: BARW, height: 3, rx: 1.5, fill: "#FF8F3A" }));
        T(n.cx, n.top - 10, "ENTRY", { s: "10", w: "800", f: "#FF8F3A" });
      }
      if (d.stage === "C") {
        var sx = n.right + 14;
        T(sx, n.cy - 3, d.name, { a: "start", s: "12.5", w: "700", f: "#1A1D21" });
        T(sx, n.cy + 13, d.users.toLocaleString() + " \u00b7 " + (d.users / Math.max(1, DATA.nodes.B.users) * 100).toFixed(1) + "% of B", { a: "start", s: "11.5", w: "600", f: "#8C95A1" });
      } else {
        var ty2 = n.top - (d.stage === "A" ? 26 : 14);
        badge(n.cx - 46, ty2 - 4, d.stage);
        T(n.cx - 32, ty2, d.name, { a: "start", s: "13", w: "700", f: "#1A1D21" });
        T(n.cx - 32, ty2 + 15, d.users.toLocaleString() + " users", { a: "start", s: "12", w: "700", f: "#8C95A1" });
      }
      svg.appendChild(g);
    });

    if (N.C1.users !== 0 || N.C2.users !== 0) {
      var gMark = A(E("g"), { class: "grp" }), by = (N.C1.cy + N.C2.cy) / 2;
      gMark.appendChild(A(E("rect"), { x: N.C1.cx - 26, y: by - 9, width: 52, height: 18, rx: 9, fill: "#EAF1FD" }));
      var mt = A(E("text"), { x: N.C1.cx, y: by + 3.5, "text-anchor": "middle", "font-size": "10.5", "font-weight": "800", fill: "#2A6FE8" }); mt.textContent = "OR"; gMark.appendChild(mt);
      svg.appendChild(gMark);
    }
  }

  /* ---------- donut ---------- */
  function renderDonut() {
    svg.setAttribute("viewBox", "0 0 1180 440");
    var pos = { A: { cx: 200, cy: 220, r: 118 }, B: { cx: 540, cy: 330, r: 86 }, C1: { cx: 830, cy: 170, r: 62 }, C2: { cx: 820, cy: 330, r: 42 }, D: { cx: 1040, cy: 240, r: 34 } };
    var ribs = [{ a: "A", b: "B", p: "all" }, { a: "B", b: "C1", p: "book" }, { a: "B", b: "C2", p: "inq" }, { a: "C1", b: "D", p: "book" }, { a: "C2", b: "D", p: "inq" }];
    function ptOn(c, ang) { return { x: c.cx + Math.cos(ang) * c.r, y: c.cy + Math.sin(ang) * c.r }; }
    var defs = E("defs");
    var lg = A(E("linearGradient"), { id: "ribg", x1: "0", x2: "1" });
    lg.appendChild(A(E("stop"), { offset: "0", "stop-color": "#CBDDFB" }));
    lg.appendChild(A(E("stop"), { offset: ".5", "stop-color": "#E7EEFC" }));
    lg.appendChild(A(E("stop"), { offset: "1", "stop-color": "#CBDDFB" }));
    defs.appendChild(lg); svg.appendChild(defs);

    var gRib = A(E("g"), { class: "grp" });
    ribs.forEach(function (r) {
      var c1 = pos[r.a], c2 = pos[r.b];
      var a12 = Math.atan2(c2.cy - c1.cy, c2.cx - c1.cx), a21 = a12 + Math.PI, ha = 0.7;
      var p1t = ptOn(c1, a12 - ha), p2t = ptOn(c2, a21 + ha), p2b = ptOn(c2, a21 - ha), p1b = ptOn(c1, a12 + ha);
      var d = "M" + p1t.x + "," + p1t.y + " Q" + ((c1.cx + c2.cx) / 2) + "," + ((p1t.y + p2t.y) / 2) + " " + p2t.x + "," + p2t.y +
        " L" + p2b.x + "," + p2b.y + " Q" + ((c1.cx + c2.cx) / 2) + "," + ((p1b.y + p2b.y) / 2) + " " + p1b.x + "," + p1b.y + " Z";
      var pa = A(E("path"), { d: d, fill: "url(#ribg)", class: "ribbon", "data-path": r.p });
      var f = DATA.flows.find(function (x) { return x.from === r.a && x.to === r.b; });
      pa.__tip = function () { return flowTip(f); }; pa.__spot = r.p; gRib.appendChild(pa);
      var mx = (c1.cx + c2.cx) / 2, my = (c1.cy + c2.cy) / 2 - 6;
      var t = A(E("text"), { x: mx, y: my, "text-anchor": "middle", "font-size": "14", "font-weight": "800", fill: "#3C4350", "paint-order": "stroke", stroke: "#fff", "stroke-width": "4", "stroke-linejoin": "round", "pointer-events": "none" });
      t.textContent = (f ? (f.value / Math.max(1, DATA.nodes[r.a].users) * 100) : 0).toFixed(1) + "%"; gRib.appendChild(t);
    });
    svg.appendChild(gRib);

    ["A", "B", "C1", "C2", "D"].forEach(function (id) {
      var n = pos[id], d = DATA.nodes[id], g = A(E("g"), { class: "grp" });
      var hit = A(E("g"), { class: "node", "data-path": d.path || "all" }); hit.__tip = function () { return nodeTip(d); }; hit.__spot = d.path || null;
      var th = Math.max(13, n.r * 0.17), rr = n.r - th / 2, C = 2 * Math.PI * rr, off = 0;
      hit.appendChild(A(E("circle"), { cx: n.cx, cy: n.cy + 5, r: n.r, fill: "rgba(16,24,40,.05)" }));
      if (id === "A") hit.appendChild(A(E("circle"), { cx: n.cx, cy: n.cy, r: n.r + 5, fill: "none", stroke: "#FF8F3A", "stroke-width": "3", "stroke-opacity": ".9" }));
      DIST.forEach(function (frac, i) {
        var len = frac * C;
        hit.appendChild(A(E("circle"), { cx: n.cx, cy: n.cy, r: rr, fill: "none", stroke: SEG[i].c, "stroke-width": th, "stroke-dasharray": len + " " + (C - len), "stroke-dashoffset": -off, transform: "rotate(-90 " + n.cx + " " + n.cy + ")" }));
        off += len;
      });
      var inner = n.r - th - 3;
      hit.appendChild(A(E("circle"), { cx: n.cx, cy: n.cy, r: inner, fill: "#fff" }));
      function T(x, y, s, o) { o = o || {}; var t = A(E("text"), { x: x, y: y, "text-anchor": "middle", "font-size": o.s, "font-weight": o.w || "700", fill: o.f, "letter-spacing": o.ls || "0", "pointer-events": "none" }); t.textContent = s; hit.appendChild(t); }
      T(n.cx, n.cy - inner * 0.5 + 4, d.stage, { s: "11", f: "#7A828E" });
      T(n.cx, n.cy + n.r * 0.05, d.users.toLocaleString(), { s: Math.max(17, n.r * 0.32), w: "800", f: "#1A1D21", ls: "-.02em" });
      T(n.cx, n.cy + n.r * 0.30, "users", { s: Math.max(9, n.r * 0.11), w: "600", f: "#9AA1AC" });
      g.appendChild(hit);
      var lt = A(E("text"), { x: n.cx, y: n.cy + n.r + 22, "text-anchor": "middle", "font-size": "13", "font-weight": "700", fill: "#3C4350", "pointer-events": "none" }); lt.textContent = d.name; g.appendChild(lt);
      svg.appendChild(g);
    });
  }

  /* ---------------------------------------------------------------- guidance ----
   * TR('funnel.f2.no_funnel_data_in_this_range_yet') was the answer to two completely different problems, and gave
   * no next step for either. Someone looking at an empty funnel needs to know WHICH of these is true:
   *   - no funnel is defined      -> define one
   *   - one exists but nobody entered it in this window -> widen the range, or the first step matches
   *     nothing (a path typo is the usual cause)
   * Silence that does not distinguish those is the thing that makes a feature feel broken.
   */
  function emptyState(kind, ctx) {
    var host = q("empty"); if (!host) return;
    ctx = ctx || {};
    var range = (RANGE && RANGE.label) ? RANGE.label : "this range";
    var html;
    if (kind === "no-funnel") {
      html = '<div class="fe-h">'+TT('funn.js.no_funnel_defined_yet')+'</div>' +
        '<p class="fe-p">A funnel is an ordered set of steps \u2014 a landing page, a pricing page, a checkout \u2014 ' +
        'and it shows you how many visitors reach each one, and where they leave.</p>' +
        '<p class="fe-p"><button type="button" class="fe-btn" data-f="fe-new">'+TT('funn.js.create_your_first_funnel')+'</button></p>';
    } else if (kind === "no-entries") {
      var first = ctx.firstStep ? (' The first step is <code>' + esc(ctx.firstStep) + '</code>.') : '';
      html = '<div class="fe-h">Nobody entered this funnel in ' + esc(range) + '</div>' +
        '<p class="fe-p">The funnel is set up, but no visitor matched its first step in this window, so there is ' +
        'nothing to show a drop-off for.' + first + '</p>' +
        '<p class="fe-p fe-acts">' +
          '<button type="button" class="fe-btn" data-f="fe-widen">Try the last 90 days</button>' +
          '<button type="button" class="fe-btn ghost" data-f="fe-edit">'+TT('funn.js.check_the_steps')+'</button>' +
        '</p>' +
        '<p class="fe-p fe-hint">A first step that matches nothing is the usual cause \u2014 a path typo, or a ' +
        'rule pointing at a page that has since been renamed.</p>';
    } else {
      html = '<div class="fe-h">'+TT('funn.js.funnel_unavailable')+'</div>' +
        '<p class="fe-p">The funnel could not be loaded. If this persists, the funnel may have been deleted ' +
        'while this page was open \u2014 reload to pick another.</p>';
    }
    host.innerHTML = html;
    host.hidden = false;
    var n = host.querySelector('[data-f="fe-new"]'); if (n) n.addEventListener("click", function () {
      var b = q("new"); if (b) b.click();
    });
    var e = host.querySelector('[data-f="fe-edit"]'); if (e) e.addEventListener("click", function () {
      var b = q("edit"); if (b) b.click();
    });
    var w = host.querySelector('[data-f="fe-widen"]'); if (w) w.addEventListener("click", function () {
      /* Actually widen it. An instruction the reader has to carry out by hand is half a fix. */
      RANGE = preset(90);
      var lab = q("range-label"); if (lab) lab.textContent = RANGE.label;
      try { localStorage.setItem("gs_funnel_range", JSON.stringify(RANGE)); } catch (err) {}
      loadFunnel(currentId);
    });
  }

  function clearSvg() { while (svg.firstChild) svg.removeChild(svg.firstChild); svg.classList.remove("in", "dim"); }
  function animateIn() { requestAnimationFrame(function () { requestAnimationFrame(function () { svg.querySelectorAll(".grp").forEach(function (g, i) { g.style.transitionDelay = (i * 45) + "ms"; }); svg.classList.add("in"); }); }); }
  function render(mode) {
    MODE = mode;
    if (!DATA.nodes.A || DATA.nodes.A.users === 0) {
      clearSvg();
      emptyState(CURRENT ? "no-entries" : "no-funnel",
                 { firstStep: (CURRENT && CURRENT.first_step) || null });
      return;
    }
    q("empty").hidden = true;
    clearSvg(); if (mode === "flow") renderFlow(); else renderDonut(); animateIn();
  }

  /* ---------- query-builder step summary ---------- */
  function renderSteps() {
    var n = DATA.nodes, host = q("steps"); if (!host) return;
    function step(letter, cls, body, right) {
      return '<div class="step ' + (cls || "") + '"><span class="badge">' + letter + '</span>' + (letter !== "D" ? '<span class="conn"></span>' : '') +
        '<div class="step__body">' + body + '</div><div class="step__right">' + right + '</div></div>';
    }
    var html = "";
    html += step("A", "", 'performed <span class="ev">' + esc(n.A.name) + '</span>', n.A.users.toLocaleString() + " entered");
    html += step("B", "", 'then performed <span class="ev">' + esc(n.B.name) + '</span>', n.B.users.toLocaleString());
    html += step("C", "branch", 'then performed <span class="ev">' + esc(n.C1.name) + '</span><span class="pill-or">OR path</span><span class="ev">' + esc(n.C2.name) + '</span>', (n.C1.users + n.C2.users).toLocaleString());
    html += step("D", "", 'then performed <span class="ev">' + esc(n.D.name) + '</span>', n.D.users.toLocaleString() + " converted");
    var evs = ((CURRENT && CURRENT.steps) || []).filter(function (s) { return s && s.kind === "page" && s.match_value; });
    if (evs.length) {
      html += '<div class="fn-ev"><div class="fn-ev-h">'+TT('funn.js.inspect_a_step_on_the_page')+'</div>' +
        evs.map(function (s) {
          var pg = String(s.match_value);
          return '<div class="fn-ev-row"><span class="fn-ev-p" title="' + esc(pg) + '">' + esc(s.label || pg) + "</span>" +
            '<a class="fn-ev-a" href="/heatmaps?page=' + encodeURIComponent(pg) + '" title="'+TT('fn.tip.heatmap')+'"><i class="bi bi-grid-1x2-fill"></i></a>' +
            '<a class="fn-ev-a" href="/session-recordings?page=' + encodeURIComponent(pg) + '" title="'+TT('fn.tip.watch')+'"><i class="bi bi-play-circle-fill"></i></a>' +
            "</div>";
        }).join("") + "</div>";
    }
    host.innerHTML = html;
  }

  /* ---------- path insights table ---------- */
  function renderPaths() {
    /* Each header explains itself. "Entered B" and "Path conv." are jargon that only makes sense
       once someone tells you the denominator — and getting the denominator wrong is how a funnel
       lies. */
    var HELP = {
      Path: TR('funnel.f3.the_distinct_route_visitors_took_t'),
      Sequence: TR('funnel.f3.the_steps_in_order_click_a_row_to_'),
      "Entered B": "Visitors who reached the second step by this path \u2014 the denominator for its conversion rate.",
      Converted: TR('funnel.f3.visitors_on_this_path_who_reached_'),
      "Path conv.": TR('funnel.f3.converted_u00f7_entered_b_for_this'),
      "Drop-off": "100% minus the path conversion: the share who entered this path and never finished."
    };
    function th(label, cls) {
      return '<th' + (cls ? ' class="' + cls + '"' : "") + ' title="' + esc(HELP[label] || "") + '"><span class="pi-h">' + esc(label) + "</span></th>";
    }
    var head = "<thead><tr>" + th("Path", "l") + th(TR('funnel.g.sequence'), "l") + th(TR('funnel.g.entered_b')) + th(TR('funnel.g.converted')) +
               th(TR('funnel.g.path_conv')) + th(TR('funnel.g.drop_off')) + "</tr></thead>";
    var body = '<tbody>';
    PATHS.forEach(function (p, idx) {
      var conv = p.entered ? (p.converted / p.entered * 100) : 0, drop = 100 - conv;
      var mx = Math.max.apply(null, srcRows(p.converted, p.dist).map(function (r) { return r.v; })) || 1;
      var srcs = srcRows(p.converted, p.dist).map(function (r) {
        return '<div class="srcbar"><span style="color:var(--f-ink-2);font-weight:600">' + r.k + '</span>' +
          '<span class="track"><span class="fill" style="background:' + r.c + ';width:' + (r.v / mx * 100) + '%"></span></span>' +
          '<span class="num" style="text-align:right;color:var(--f-muted)">' + r.v.toLocaleString() + '</span></div>';
      }).join("");
      body += '<tr class="prow" data-i="' + idx + '" data-spot="' + p.spot + '">' +
        // the cell can truncate now, so the full path lives in the title — nothing is lost,
        // it is one hover away
        '<td class="l" title="' + esc(p.label) + '"><span class="path-chip"><span class="dt" style="background:' + p.color + '"></span><span class="pth">' + esc(p.label) + '</span>' +
        '<i class="bi bi-chevron-right car"></i></span></td>' +
        '<td class="l num" style="color:var(--f-muted)" title="' + esc(p.steps) + '">' + esc(p.steps) + '</td>' +
        '<td class="num">' + (+p.entered).toLocaleString() + '</td>' +
        '<td class="num">' + (+p.converted).toLocaleString() + '</td>' +
        '<td class="num conv-strong">' + conv.toFixed(2) + '%</td>' +
        '<td class="num drop-strong">' + drop.toFixed(1) + '%</td></tr>' +
        '<tr class="detail" data-i="' + idx + '"><td colspan="6"><div class="detail-inner">' +
        '<div style="font-size:11px;font-weight:700;color:var(--f-muted);text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px">'+TT('funn.js.conversions_by_source')+'</div>' + srcs + '</div></td></tr>';
    });
    body += '</tbody>';
    q("paths").innerHTML = head + body;
    qa("tr.prow").forEach(function (row) {
      var i = row.getAttribute("data-i"), spot = row.getAttribute("data-spot");
      var det = root.querySelector('tr.detail[data-i="' + i + '"]');
      row.addEventListener("click", function () { row.classList.toggle("open"); det.classList.toggle("open"); });
      row.addEventListener("mouseenter", function () { spotlight(spot); });
      row.addEventListener("mouseleave", function () { spotlight(null); });
    });
  }

  /* ---------- data loading ---------- */
  /* The date picker has been in the markup since day one — pills, presets, custom range, Apply —
     and the backend has always read ?from=&to=. The JS wired neither: no handler on the buttons,
     and no from/to on the request. So every preset was decorative and every report silently showed
     the backend's default (last 30 days). That is why the dates "don't work": nothing was broken,
     nothing was connected.

     A stored preset re-anchors to today on load. Restoring its absolute dates would freeze the
     funnel on whenever you last touched the picker — the bug that made Refresh useless everywhere
     else. A custom range IS absolute and is kept as stored. */
  function _ymd(d) { return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2); }
  function _today() { var t = new Date(); return new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate())); }
  function T(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function preset(k) {
    var to = _today(), from = new Date(to.getTime());
    var lbl, d = parseInt(k, 10);
    if (!isNaN(d)) { from = new Date(to.getTime() - (d - 1) * 86400000);
      lbl = { 7: T("an.last7"), 30: T("an.last30"), 90: T("an.last90") }[d] || T("an.lastndays",{n:d}); }
    else if (k === "today")     { lbl = TR('funnel.g.today'); }
    else if (k === "yesterday") { to = new Date(to.getTime() - 86400000); from = new Date(to.getTime()); lbl = TR('funnel.g.yesterday'); }
    else if (k === "thisweek")  { from = new Date(to.getTime() - ((to.getUTCDay() + 6) % 7) * 86400000); lbl = TR('funnel.this_week'); }
    else if (k === "lastweek")  { var m = new Date(to.getTime() - ((to.getUTCDay() + 6) % 7) * 86400000);
                                  to = new Date(m.getTime() - 86400000); from = new Date(to.getTime() - 6 * 86400000); lbl = TR('funnel.g.last_week'); }
    else if (k === "thismonth") { from = new Date(Date.UTC(to.getUTCFullYear(), to.getUTCMonth(), 1)); lbl = TR('funnel.this_month'); }
    else if (k === "lastmonth") { to = new Date(Date.UTC(to.getUTCFullYear(), to.getUTCMonth(), 0));
                                  from = new Date(Date.UTC(to.getUTCFullYear(), to.getUTCMonth(), 1)); lbl = TR('funnel.g.last_month'); }
    else { from = new Date(to.getTime() - 29 * 86400000); lbl = T("an.last30"); k = "30"; }
    return { from: _ymd(from), to: _ymd(to), label: lbl, preset: String(k) };
  }
  var RANGE = (function () {
    try {
      var s = JSON.parse(localStorage.getItem("gs_funnel_range") || "null");
      if (s && s.preset) return preset(s.preset);        // a preset is a rule: re-anchor to today
      if (s && s.from && s.to) return s;                 // a custom range is absolute: keep it
    } catch (e) {}
    return preset("30");
  })();
  function saveRange() { try { localStorage.setItem("gs_funnel_range", JSON.stringify(RANGE)); } catch (e) {} }
  function rangeParam() { return "&from=" + RANGE.from + "&to=" + RANGE.to; }
  /* Optional segment scope from the URL (?device= / ?country=): the VI Segment view deep-links here
     so a funnel opens filtered to that audience. The backend constrains every step to the segment.
     Named SEGF, not SEG: SEG is already this file's donut/flow colour palette (see top of file). */
  var SEGF = (function () {
    try {
      var p = new URLSearchParams(location.search);
      var d = (p.get("device") || "").toLowerCase().replace(/[^a-z]/g, "");
      var c = (p.get("country") || "").toUpperCase().replace(/[^A-Z]/g, "").slice(0, 2);
      return { device: d || null, country: c.length === 2 ? c : null };
    } catch (e) { return { device: null, country: null }; }
  })();
  function segParam() {
    var s = "";
    if (SEGF.device) s += "&device=" + encodeURIComponent(SEGF.device);
    if (SEGF.country) s += "&country=" + encodeURIComponent(SEGF.country);
    return s;
  }
  function showSegChip() {
    if (!SEGF.device && !SEGF.country) return;
    if (document.getElementById("fn-seg-chip")) return;
    var host = q("rangeBtn") || q("range-label"); if (!host || !host.parentNode) return;
    var lbl = SEGF.device || ("country " + SEGF.country);
    var chip = document.createElement("span");
    chip.id = "fn-seg-chip";
    chip.style.cssText = "display:inline-flex;align-items:center;gap:5px;margin-left:8px;padding:3px 9px;border-radius:20px;background:#EAF2FE;color:#2A6FE8;font-size:12px;font-weight:700;border:1px solid #CFE0FA;vertical-align:middle";
    chip.innerHTML = '<i class="bi bi-people-fill"></i>' + lbl + " segment";
    chip.title = "This funnel is filtered to the " + lbl + " segment (deep-linked from Visitor Intelligence).";
    host.parentNode.insertBefore(chip, host.nextSibling);
  }

  function initRange() {
    var btn = q("rangeBtn"), menu = q("rangeMenu"), lab = q("range-label");
    if (!btn || !menu) return;
    if (lab && RANGE.label) lab.textContent = RANGE.label;
    function apply(r) {
      RANGE = r; if (lab) lab.textContent = RANGE.label; saveRange();
      menu.style.display = "none";
      qa('[data-f="rangeMenu"] .rm').forEach(function (b) { b.classList.toggle("on", b.getAttribute("data-preset") === RANGE.preset); });
      loadFunnel(currentId);
    }
    btn.addEventListener("click", function (e) {
      if (menu.contains(e.target) && e.target !== btn) return;
      e.stopPropagation(); menu.style.display = menu.style.display === "none" ? "block" : "none";
    });
    document.addEventListener("click", function () { menu.style.display = "none"; });
    menu.addEventListener("click", function (e) { e.stopPropagation(); });
    menu.querySelectorAll(".rm[data-preset]").forEach(function (b) {
      b.addEventListener("click", function () { apply(preset(b.getAttribute("data-preset"))); });
    });
    var f = menu.querySelector('[data-rp="from"]'), t = menu.querySelector('[data-rp="to"]'), ap = menu.querySelector('[data-rp="apply"]');
    if (f) f.value = RANGE.from; if (t) t.value = RANGE.to;
    if (ap) ap.addEventListener("click", function () {
      var a = f && f.value, b = t && t.value;
      if (!a || !b) return;
      if (a > b) { var x = a; a = b; b = x; }            // a backwards range returns nothing; swap it
      apply({ from: a, to: b, label: a + " \u2192 " + b, preset: null });
    });
    qa('[data-f="rangeMenu"] .rm').forEach(function (b) { b.classList.toggle("on", b.getAttribute("data-preset") === RANGE.preset); });
  }

  var currentId = 0, CURRENT = null;   // CURRENT holds the loaded funnel: the pencil edits THIS
  function loadFunnel(id) {
    currentId = id || 0;
    GS.api("/plugin/funnels/get?" + siteParam() + (currentId ? "&id=" + currentId : "") + rangeParam() + segParam()).then(function (r) {
      if (!r.ok || !r.data || r.data.error) {
        /* No funnel at all reads differently from a funnel that failed to load. */
        var noneYet = !!(r.data && /no funnel|not found/i.test(String(r.data.error || "")));
        emptyState(noneYet ? "no-funnel" : "error");
        return;
      }
      var d = r.data;
      DATA = { nodes: d.nodes, flows: d.flows }; SEG = d.seg || []; DIST = d.dist || []; PATHS = d.paths || [];
      ENTRY = Math.max(1, d.entry || 1);
      currentId = d.funnel ? d.funnel.id : currentId;
      /* The API returns the funnel row in d.funnel and its STEP DEFINITIONS separately in d.steps.
         CURRENT was only the row, so the editor received a funnel with no steps, decided it had fewer
         than two, and silently swapped in blank ones — the name survived and every path was lost. Merge
         them so the pencil edits what is actually on screen. */
      CURRENT = d.funnel ? Object.assign({}, d.funnel, { steps: d.steps || [] }) : null;
      var inst = q("install"); if (inst) inst.hidden = (d.entry || 0) > 0;
      q("title").textContent = (d.funnel && d.funnel.name) || "Funnel";
      q("ov-conv").innerHTML = (d.stats.overall_conv != null ? d.stats.overall_conv : 0) + '<small>%</small>';
      q("ov-entry").textContent = (d.entry || 0).toLocaleString();
      q("best").textContent = (d.stats.best_path || "\u2014") + (d.stats.best_conv ? " (" + d.stats.best_conv + "%)" : "");
      q("segLegend").innerHTML = SEG.map(function (s) { return '<span><i style="background:' + s.c + '"></i>' + s.k + '</span>'; }).join("");
      renderSteps(); renderPaths(); render(MODE); loadBehav();
    });
  }

  /* `want` is the funnel to land on after a save — otherwise a funnel you just built would be
     created correctly and leave you looking at the first one in the list. 0/absent keeps the
     current selection where it still exists, so a save does not yank you elsewhere. */
  function loadList(want) {
    GS.api("/plugin/funnels/list?" + siteParam()).then(function (r) {
      var fs = (r.ok && r.data && r.data.funnels) || [];
      var pick = q("picker");
      var target = 0;
      if (want && fs.some(function (f) { return +f.id === +want; })) target = +want;
      else if (currentId && fs.some(function (f) { return +f.id === +currentId; })) target = currentId;
      else if (fs.length) target = +fs[0].id;
      if (pick) pick.innerHTML = fs.map(function (f) { return '<option value="' + f.id + '">' + esc(f.name) + '</option>'; }).join("") || '<option>'+TT('funn.js.no_funnels')+'</option>';
      if (pick && target) pick.value = String(target);
      var ed = q("edit"); if (ed) ed.disabled = !target;      // nothing selected, nothing to edit
      loadFunnel(target);
    });
  }

  function init() {
    root = document.querySelector('[data-f="root"]'); if (!root) return;
    svg = q("funnel"); tip = q("tip");

    svg.addEventListener("mousemove", function (e) {
      var t = e.target, host = null;
      while (t && t !== svg) { if (t.__tip) { host = t; break; } t = t.parentNode; }
      if (host) { showTip(host.__tip(), e.clientX, e.clientY); if (host.__spot !== undefined && host.__spot !== null && host.__spot !== "all") spotlight(host.__spot); else spotlight(null); }
      else { hideTip(); spotlight(null); }
    });
    svg.addEventListener("mouseleave", function () { hideTip(); spotlight(null); });

    var vizPill = q("vizPill"), vizMenu = q("vizMenu");
    vizPill.addEventListener("click", function (e) { e.stopPropagation(); vizMenu.classList.toggle("open"); });
    document.addEventListener("click", function () { vizMenu.classList.remove("open"); });
    qa('[data-f="vizMenu"] .mi').forEach(function (mi) {
      mi.addEventListener("click", function (e) {
        e.stopPropagation();
        qa('[data-f="vizMenu"] .mi').forEach(function (x) { x.classList.remove("sel"); });
        mi.classList.add("sel");
        q("vizLabel").textContent = mi.textContent.trim();
        vizMenu.classList.remove("open");
        render(mi.getAttribute("data-viz"));
      });
    });

    initRange();
    var pick = q("picker"); if (pick) pick.addEventListener("change", function () { loadFunnel(+pick.value); if (w.GSLink) w.GSLink.write({ id: pick.value }); });

    /* The builder posts to an endpoint that has existed all along; these two buttons are the only
       thing that was missing. After a save we reload the list and open whatever came back, so a
       new funnel lands on screen instead of leaving you to find it in the picker. */
    var nw = q("new");
    if (nw && w.GSFunnelBuilder) nw.addEventListener("click", function () {
      w.GSFunnelBuilder.create(function (id) { loadList(id || 0); });
    });
    var ed = q("edit");
    if (ed && w.GSFunnelBuilder) ed.addEventListener("click", function () {
      if (!CURRENT) return;
      w.GSFunnelBuilder.edit(CURRENT, function (id) { loadList(id || 0); });
    });
    var refresh = q("refresh"); if (refresh) refresh.addEventListener("click", function () { loadFunnel(currentId); });

    loadList();
  }

  /* Deep link: /funnels?id=<n> opens that funnel. loadList() populates the picker, so the id is
     applied once the options exist — setting .value before then silently does nothing and the page
     would open the default funnel while the URL claimed otherwise. */
  function gsDeep() {
    var id = null;
    if (w.GSLink) id = w.GSLink.read({ id: "int" }).id;
    else { try { var v = parseInt(String(new URLSearchParams(location.search).get("id") || "").replace(/[^0-9-]/g, ""), 10); id = isNaN(v) ? null : v; } catch (e) { id = null; } }
    if (id === null) return;
    var n = 0, t = setInterval(function () {
      var pick = q("picker");
      if (pick && pick.querySelector('option[value="' + id + '"]')) { clearInterval(t); pick.value = String(id); loadFunnel(id); }
      else if (++n > 60) clearInterval(t);      // funnel deleted, or not visible to this user
    }, 50);
  }

  ready(function () { init(); gsDeep(); showSegChip(); });
})();
